module.exports = __webpack_public_path__ + "img/Excel-Logo.89b40f03.png";